export const MailroomIcon = ({ color = "#784EFF" }: { color?: string }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="EnvelopeSimple" clipPath="url(#clip0_110_16278)">
        <path
          id="Vector"
          opacity="0.2"
          d="M21.6265 6.10217L12.6265 14.3522L3.62646 6.10217H21.6265Z"
          fill={color}
        />
        <path
          id="Vector_2"
          d="M3.62646 6.10217H21.6265V18.8522C21.6265 19.0511 21.5474 19.2419 21.4068 19.3825C21.2661 19.5232 21.0754 19.6022 20.8765 19.6022H4.37646C4.17755 19.6022 3.98679 19.5232 3.84613 19.3825C3.70548 19.2419 3.62646 19.0511 3.62646 18.8522V6.10217Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M21.6265 6.10217L12.6265 14.3522L3.62646 6.10217"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_110_16278">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.626465 0.852173)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
